"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../openapi");
let MismatchedContextOrgError = class MismatchedContextOrgError extends Error {
    contextOrgKey;
    orgKey;
    constructor(contextOrg, orgKey) {
        const message = `Context Org ${contextOrg} does not match the OrgKey ${orgKey}`;
        super(message);
        this.contextOrgKey = contextOrg;
        this.orgKey = orgKey;
    }
};
__decorate([
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'The string key of the context Org',
        format: 'uuid',
    })
], MismatchedContextOrgError.prototype, "contextOrgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'The string key of the request Org',
        format: 'uuid',
    })
], MismatchedContextOrgError.prototype, "orgKey", void 0);
MismatchedContextOrgError = __decorate([
    (0, openapi_1.ClassSchema)({
        description: 'Error thrown by a handler when request org and context org are mismatched',
    })
], MismatchedContextOrgError);
exports.default = MismatchedContextOrgError;
